<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Состояния заказов</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="defaultSortDirection"
        >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="Наименование" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="description" label="Описание" sortable>
            {{ props.row.description }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { EventBus } from "@/utils"
export default {
  name: "AdminSettingState",
  data() {
    const data = []
    return {
      data: data,
      defaultSortDirection: 'asc'
    }
  },
  mounted: function() {
    this.$store.dispatch('getStates')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
  },
  methods: {
    editRow(item){
      EventBus.$emit("showModal", "state.edit", item)
    },
    add(){
      EventBus.$emit("showModal", "state.add", null)
    }
  }
}
</script>